<template>
  <router-view />
</template>

<script>
export default {
  name: "app-edgeSpacer"
};
</script>

<style lang="scss" scoped></style>
